import { Checkbox, FormControlLabel, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { mapCheckboxStyles } from './styles'

const useStyles = makeStyles((theme) => ({
  sydCheckbox: mapCheckboxStyles(theme, {})
}))

const SydCheckbox = forwardRef(function SydCheckbox ({
  className,
  name,
  onChange = noop,
  onBlur = noop,
  value: _value,
  defaultValue = false,
  disabled = false,
  size = 'medium',
  label,
  color = 'primary',
  labelPlacement = 'end'
}, ref) {
  const classes = useStyles({ size, disabled })
  const [value, setValue] = useState(defaultValue)

  useImperativeHandle(ref, () => ({
    clear: () => setValue(defaultValue),
    focus: () => {},
    value
  }), [value, defaultValue])

  const handleChange = useCallback((event) => {
    const newValue = event.target.checked
    setValue(newValue)
    onChange(event, newValue)
  }, [setValue, onChange])

  const handleBlur = useCallback((event) => {
    onBlur(event)
  }, [onBlur])

  useEffect(() => {
    if (_value === undefined) return
    if (value === _value) return
    setValue(_value)
  }, [_value, value, setValue])

  const checkbox = (
    <Checkbox
      className={clsx(classes.sydCheckbox, className)}
      name={name}
      checked={_value !== undefined ? _value : value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      color={color}
      disableRipple
      size={size}
    />
  )

  if (label) {
    return (
      <FormControlLabel
        control={checkbox}
        label={label}
        labelPlacement={labelPlacement}
        disabled={disabled}
      />
    )
  }

  return checkbox
})

SydCheckbox.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  label: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom'])
}

SydCheckbox.defaultProps = {
  defaultValue: false,
  disabled: false,
  size: 'medium',
  color: 'primary',
  labelPlacement: 'end'
}

export default SydCheckbox
